"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FeTableRow = function FeTableRow(props) {
  return _react.default.createElement("div", {
    className: "fe-table__row",
    role: "row"
  }, props.children);
};

var _default = FeTableRow;
exports.default = _default;